import { TRUSTPULSE_HIDDEN_PATHS } from "@/config/trustPulse";

const stripTrailingSlash = (path: string) => (path.length > 1 ? path.replace(/\/+$/, "") : path);

/**
 * Whether the TrustPulse pop-up should be hidden on `pathname`: true when it
 * is one of the hidden paths or sits under one. "/cart" matches "/cart/" and
 * "/cart/anything", but not "/cartoons".
 */
export const isTrustPulseHidden = (
  pathname: string | null | undefined,
  hiddenPaths: string[] = TRUSTPULSE_HIDDEN_PATHS,
): boolean => {
  if (!pathname) {
    return false;
  }

  const path = stripTrailingSlash(pathname);
  return hiddenPaths.some((hidden) => {
    const prefix = stripTrailingSlash(hidden);
    return path === prefix || path.startsWith(`${prefix}/`);
  });
};
